// @flow
import { INSTAGRAM } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_COMMON_INSTAGRAM } from 'Utils/request/requestDictionary';
import * as configQueries from 'Views/configQueries';

export type CMSProps = {|
  id: string,
  resortIds: Array<string>,
  title: string,
|};

export type GQLProps = {|
  config: { price: { format: { from: string } } },
  products: $ReadOnlyArray<{
    duration: null | string,
    href: null | string,
    id: string,
    name: null | string,
    price: null | $Exact<ProductPrice>,
    socialPictures: $ReadOnlyArray<SocialPicture>,
    type: string,
  }>,
|};

export const instagramResolver = {
  name: INSTAGRAM,
  resolve: async (appContext: AppContext, props: CMSProps): Promise<GQLProps> => {
    const { resortIds } = props;
    const resortIdsAsString = JSON.stringify(resortIds);

    const query = `query {
      config {
        common {
          close
          scrollBackward
          scrollForward
        }
        ${configQueries.price()}
        ${configQueries.resort(appContext)}
      }
      products: resorts(resortIds: ${resortIdsAsString}) {
        duration,
        href
        id
        name
        price {
          bestPrice {
            value
            formattedValue
          }
          termsAndConditions {
            departureCity {
              value
              name
            }
            departureDate
            arrivalDate
            duration
            durationFormatted
            accommodationComfortLabel
            numberOfAdults
          }
          unit
        }
        socialPictures {
          imageLarge,
          imageSmall,
          userName,
          canonicalUrl,
        }
        type
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_COMMON_INSTAGRAM,
    });
  },
};
